import { DAYS } from '../constants/date';

export const mapTrendsChartData = (theme, activities) => {
  const todaysDate = new Date().toLocaleDateString('en-CA');

  const previous7days = [...Array(7)].map((_, i) => {
    const d = new Date(todaysDate);
    d.setDate(d.getDate() - i);
    return d;
  });

  const timeOneWeekAgo = [...previous7days].pop().getTime();

  const filteredData = activities?.filter((a) => a.date >= timeOneWeekAgo);

  const defaultChartData = [];

  previous7days.map((day) => {
    defaultChartData.push({
      day: DAYS[day.getDay()],
      distance: 0,
      mood: 0,
    });
  });

  filteredData.forEach((obj) => {
    const obj2 = defaultChartData.find(
      (o) => o.day === DAYS[new Date(obj.date).getDay()],
    );

    if (obj2) {
      obj2.distance += obj.distance;

      if (obj2.mood > 0) {
        obj2.mood = Math.round((obj2.mood + obj.mood) / 2);
      } else {
        obj2.mood += obj.mood;
      }
    }
  });

  defaultChartData.reverse();

  const series = [
    {
      type: 'bar',
      stack: '',
      yAxisKey: 'miles',
      color: theme.palette.tertiary.main,
      data: defaultChartData?.map(({ distance }) => distance),
    },
    {
      type: 'line',
      yAxisKey: 'mood',
      color: theme.palette.quaternary.main,
      data: defaultChartData?.map(({ mood }) => mood),
    },
  ];

  const xAxis = [
    {
      id: 'days',
      data: defaultChartData?.map(({ day }) => day),
      scaleType: 'band',
    },
  ];

  const yAxis = [
    {
      id: 'miles',
      scaleType: 'linear',
      min: 0,
    },
    {
      id: 'mood',
      scaleType: 'linear',
      min: 0,
      max: 5,
    },
  ];

  return { series, xAxis, yAxis };
};
